<template>
  <section class="section small-padding">
    <div class="container">
      <div class="row">
          <div class="col-md-6">
            <h2>Unidades de Medida</h2>
          </div>
          <div class="col-md-6 text-right">
              <a @click="create()"  style="margin-top: 1em;" class="btn btn-fill">Nueva</a>
          </div>
      </div>     
      <div class="panel-group">
        <div class="row">
                                  <div class="col-md-12 text-center" v-if="loading">
                                    <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                                  </div>
                                  <div v-if="!loading&&units.length==0" class="text-center">
                                    <h2>No hay Unidades de Medida</h2>
                                  </div>
        </div>
        <div>
        <table class="table" v-if="!loading&&units.length>0">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Inglés</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(camp,idx) in units">
              <td>
                <a @click="edit(camp)" class="text-brand"><label style="cursor:pointer;">{{camp.name}}</label></a>
              </td>
              <td>{{camp.english}}</td>
              <td>
                <span class="label btn-danger" style="cursor:pointer;" @click="removeUnit(camp)">Eliminar</span>                
              </td>
            </tr>
          </tbody>
        </table>
        </div>     
      </div>
    </div>

    <div class="modal" ref="modalEdit" role="dialog">
      <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 class="modal-title">Unidad de Medida</h4>
                </div>
                  <div class="modal-body">
                    <div class="row">
          <form class="form smart-form">
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="">Nombre</label>
                    <div class="input">
                      <input type="text" class="form-control" v-model="unit.name">
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <div class="form-group">
                    <label for="">Inglés</label>
                    <div class="input">
                      <input type="text" class="form-control" v-model="unit.english">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

                    </div>
                    <div class="row">
                      <div class="form-group">
                        <div class="text-center center-block">
                          <button class="btn btn-fill" @click="saveUnit()">Guardar</button>
                        </div>
                      </div>                    
                    </div>
                  </div>
            </div>
      </div>
    </div>

  </section>
</template>
<script>
import moment from 'moment'
import swal from 'sweetalert2'
import $ from 'jquery'

moment.locale('es')

export default {
  computed: {
  },
  data () {
    return {
      sucursales: [],
      units: [],
      unit: {},
      page: 0,
      offset: 0,
      loading: false
    }
  },
  methods: {
    edit (unit) {
      const me = this
      me.unit = Object.assign({}, unit)
      $(me.$refs.modalEdit).modal()
    },
    create () {
      const me = this
      me.unit = {}
      $(me.$refs.modalEdit).modal()
    },
    saveUnit () {
      const me = this
      if (me.unit.name && me.unit.english) {
        me.$http.post('/api/admin/measureUnits', me.unit).then(({body}) => {
          me.$emit('mostrar-notificacion', 'La unidad de medida se ha guardado', 'success')
          $(me.$refs.modalEdit).modal('hide')
          me.cargar()
        }, (err) => {
          console.error(err)
        })
      } else {
        me.$emit('mostrar-notificacion', 'Se necesita ingresar el nombre y su traducción al inglés', 'warning')
      }
    },
    removeUnit (unit) {
      const me = this
      swal({
        title: 'Confirme operación',
        text: '¿Desea eliminar la unidad "' + unit.name + '"?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No, dejar sin efecto'
      }).then(() => {
        me.$http.delete('/api/admin/measureUnits/' + unit._id).then(({body}) => {
          me.cargar()
        }, (err) => {
          console.log(err)
        })
      }, (dismiss) => {
        return false
      })
    },
    cargar () {
      const me = this
      me.loading = true
      me.$http.get('/api/admin/measureUnits', {}).then(({body}) => {
        me.units = body
        me.loading = false
      }, (err) => {
        me.loading = false
        this.$emit('mostrar-notificacion', 'error', err)
      })
    }
  },
  mounted () {
    const me = this
    me.cargar()
  },
  watch: {
  }
}
</script>
<style scoped>
.modal {
  background-color: white;
}
.derecha {
  text-align: right;
}
.status-recibido {
  background-color: #F28893;
  color: #333;
}
.status-cocina {
  background-color: #FFC182;
  color: #333;
}
.status-empaquetado {
  background-color: #74A9B3;
  color: #333;
}
.status-entregado {
  background-color: #93A512;
  color: #333;
}
.status-cancelado {
  background-color: #666;
  color: #FFF;
}

</style>



// WEBPACK FOOTER //
// List.vue?0f150c9a